import React, { ChangeEvent, useCallback, useEffect, useState } from 'react';
import { useFocusTabFinalizacao } from '~/pages/PdvOnline/hooks/useFocusTabFinalizacao';
import { useFocusTabProduto } from '~/pages/PdvOnline/hooks/useFocusTabProduto';
import { usePdvOnline } from '~/pages/PdvOnline/hooks/usePdvOnline';
import { Modal } from '..';
import {
  AmountContainer,
  ButtonContainer,
  Container,
  QuantityText,
  Title,
} from './styles';
import { InputMoney } from '~/components/NovosInputs';
import { useForm } from 'react-hook-form';
import { formatCurrencyAsText, transformAsCurrency } from '~/utils/functions';
import { Button } from '../../TabProdutos/style';

export const ModalGranel: React.FC = () => {
  const {
    isOpenModalGranel,
    handleChangeOpenModalGranel,
    tabActive,
    onCloseModal,
    selectProduto,
    formTabProduto,
  } = usePdvOnline();

  const { setValueTabProduto } = formTabProduto;

  const { handleInputFocus } = useFocusTabProduto();
  const { handleInputFocus: focusTabFinalizacao } = useFocusTabFinalizacao();

  const { register, control, setValue, watch, formState, setFocus } = useForm();

  const granelValorAPagar = watch('granel_val_pagar');

  const [quantidade, setQuantidade] = useState('1');

  useEffect(() => {
    if (isOpenModalGranel) {
      setFocus('granel_val_pagar');
    }
  }, [setFocus, isOpenModalGranel]);

  useEffect(() => {
    const handleCloseModal = (event: KeyboardEvent) => {
      if (isOpenModalGranel && event.key === 'Escape') {
        handleChangeOpenModalGranel(false);
        if (tabActive === 'PRODUTOS') handleInputFocus('leitor');
        else if (tabActive === 'FINALIZACAO') focusTabFinalizacao('num_cpf');
      }
    };

    document.addEventListener('keydown', handleCloseModal);
    return () => document.removeEventListener('keydown', handleCloseModal);
  }, [
    focusTabFinalizacao,
    handleChangeOpenModalGranel,
    handleInputFocus,
    isOpenModalGranel,
    onCloseModal,
    tabActive,
  ]);

  useEffect(() => {
    const modal: HTMLDivElement | null = document.querySelector(
      '[id="modal-funcao"]',
    );

    if (modal && isOpenModalGranel) modal.focus();
  }, [isOpenModalGranel]);

  useEffect(() => {
    if (selectProduto) {
      const quantidadeTotal =
        transformAsCurrency(granelValorAPagar || 1) /
        Number(selectProduto.val_preco);
      setQuantidade(formatCurrencyAsText(quantidadeTotal, 3));
    }
  }, [granelValorAPagar, selectProduto]);

  useEffect(() => {
    if (selectProduto) {
      setValue(
        'granel_val_pagar',
        formatCurrencyAsText(Number(selectProduto.val_preco)),
      );
    }
  }, [selectProduto, setValue, isOpenModalGranel]);

  const handleCloseModal = useCallback(() => {
    setValue('granel_val_pagar', 1);
    handleChangeOpenModalGranel(false);
  }, [handleChangeOpenModalGranel, setValue]);

  const handlePrecoProduto = useCallback(() => {
    setValueTabProduto('qtd_produto', formatCurrencyAsText(quantidade));
    handleCloseModal();
  }, [handleCloseModal, quantidade, setValueTabProduto]);

  return (
    <Modal
      isOpen={isOpenModalGranel}
      title="Calcular Quantidade Granel"
      onClose={() => handleCloseModal()}
    >
      <Container>
        <Title>Valor a Pagar</Title>
        <AmountContainer>
          <InputMoney
            placeholder="0,00"
            min={0}
            decimals={2}
            maxLength={9999}
            max={9999}
            name="granel_val_pagar"
            register={register}
            control={control}
            isError={!!formState.errors.granel_val_pagar}
            showIcon
            onInput={(ev: ChangeEvent<HTMLInputElement>) => {
              const { value } = ev.target;
              setValue('granel_val_pagar', value);
            }}
          />
        </AmountContainer>
        <Title>Quantidade</Title>
        <QuantityText>{quantidade}</QuantityText>
        <ButtonContainer>
          <Button
            onClick={async () => handleCloseModal()}
            className="clearButton"
            type="button"
          >
            Cancelar
          </Button>
          <Button
            onClick={async () => handlePrecoProduto()}
            className="addButton"
            type="button"
          >
            Aceitar
          </Button>
        </ButtonContainer>
      </Container>
    </Modal>
  );
};
